module.exports = ".error-title {\n  font-weight: bold; }\n\n.error-list {\n  margin-left: 0;\n  padding-left: 0;\n  list-style-type: none;\n  font-style: italic; }\n\n.ft-icon-search {\n  float: right;\n  position: absolute;\n  top: 7px;\n  right: 0; }\n\n.search-box {\n  padding-right: 23px; }\n\n.date-input-fields-wrap {\n  width: 50%; }\n\n.example-full-width {\n  width: 89%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/form-field/form-field.component.scss
// module id = ./src/app/components/form-field/form-field.component.scss
// module chunks = main